import styled from 'styled-components';
import { colors } from '../colors';

const TitleHeaderLeft = styled.div`
	font-family: 'RubikMedium';
	font-size: 20px;
	line-height: 24px;
	color: ${colors.Black};
`;

export default TitleHeaderLeft;
